import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab"]

  switch(event) {
    event.preventDefault()
    this.tabTargets.forEach(function(t) { t.classList.remove("active") })
    event.currentTarget.classList.add("active")
  }
}
